import styled from 'styled-components';

import Button from '../Button';
import addButtonStyles from './addButtonStyles';

const StyledAddButton = styled(Button)`${addButtonStyles}`;

export default StyledAddButton;



// WEBPACK FOOTER //
// ./app/components/AddItemButton/StyledAddButton.js